export default function getGPSListUrl(): string {
  return 'kv/gps';
}
